import styled from 'styled-components';
export const Container = styled.div`
  align-items: center;
  display: flex;
  height: ${_ref => {
  let {
    inputSize
  } = _ref;
  return inputSize === 'sm' ? '48px' : inputSize === 'md' ? '56px' : '64px';
}};
  justify-content: center;
  width: ${_ref2 => {
  let {
    inputSize
  } = _ref2;
  return inputSize === 'sm' ? '48px' : inputSize === 'md' ? '56px' : '64px';
}};
`;
export const Label = styled.label`
  background-color: ${_ref3 => {
  let {
    theme,
    disabled
  } = _ref3;
  return theme.colors.secondaryL2 + (disabled ? '20' : '');
}};
  border-radius: 25px;
  border: none;
  cursor: ${_ref4 => {
  let {
    disabled
  } = _ref4;
  return disabled ? 'not-allowed' : 'pointer';
}};
  display: block;
  height: ${_ref5 => {
  let {
    inputSize
  } = _ref5;
  return inputSize === 'sm' ? '20px' : inputSize === 'md' ? '23px' : '27px';
}};
  position: relative;
  transition: background-color 0.2s;
  width: ${_ref6 => {
  let {
    inputSize
  } = _ref6;
  return inputSize === 'sm' ? '36px' : inputSize === 'md' ? '42px' : '48px';
}};

  &:focus {
    outline: ${_ref7 => {
  let {
    theme,
    disabled
  } = _ref7;
  return disabled ? 'none' : `2px solid ${theme.colors.secondaryL3}`;
}};
  }

  &:hover {
    background-color: ${_ref8 => {
  let {
    theme,
    disabled
  } = _ref8;
  return !disabled && theme.colors.secondaryL3;
}};
  }

  &::after {
    background-color: ${_ref9 => {
  let {
    theme
  } = _ref9;
  return theme.colors.neutralL5;
}};
    border-radius: ${_ref10 => {
  let {
    inputSize
  } = _ref10;
  return inputSize === 'sm' ? '25px' : inputSize === 'md' ? '9.5px' : '11px';
}};
    content: '';
    cursor: ${_ref11 => {
  let {
    disabled
  } = _ref11;
  return disabled ? 'not-allowed' : 'pointer';
}};
    display: block;
    height: ${_ref12 => {
  let {
    inputSize
  } = _ref12;
  return inputSize === 'sm' ? '16px' : inputSize === 'md' ? '19px' : '22px';
}};
    left: ${_ref13 => {
  let {
    inputSize
  } = _ref13;
  return inputSize === 'sm' ? '2px' : inputSize === 'md' ? '2px' : '2.5px';
}};
    opacity: ${_ref14 => {
  let {
    disabled
  } = _ref14;
  return disabled ? '0.3' : '1';
}};
    position: absolute;
    top: 2px;
    transition: 0.4s;
    width: ${_ref15 => {
  let {
    inputSize
  } = _ref15;
  return inputSize === 'sm' ? '16px' : inputSize === 'md' ? '19px' : '22px';
}};
  }
`;
export const Input = styled.input`
  display: none;
  &:checked + ${Label} {
    background-color: ${_ref16 => {
  let {
    theme
  } = _ref16;
  return theme.colors.primary;
}};
  }

  &:checked ~ ${Label}::after {
    left: ${_ref17 => {
  let {
    inputSize
  } = _ref17;
  return inputSize === 'sm' ? '18px' : inputSize === 'md' ? '20px' : '23px';
}};
  }
`;